import * as React from "react";

const IconViewEdit: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path
                fill="currentColor"
                d="M7.734375,3.23203111 L8.76796889,4.265625 L5.47734368,7.55624986 L4.29609346,7.70390582 L4.44374979,6.52265596 L7.734375,3.23203111 Z M9.9609375,4.6640625 L10.359375,4.265625 L11.2054689,3.41953111 L12,2.625 L11.2054689,1.83046889 L10.1695311,0.794531107 L9.375,0 L8.58046889,0.794531107 L7.734375,1.640625 L7.3359375,2.0390625 L6.9375,2.4375 L3.375,6 L3.14296889,7.84921861 L3,9 L4.15078139,8.85703111 L6,8.625 L9.5625,5.0625 L9.9609375,4.6640625 Z M9.5625,3.47109389 L8.52890611,2.4375 L9.375,1.59140611 L10.4085939,2.625 L9.5625,3.47109389 Z M0.5625,1.5 L0,1.5 L0,2.0625 L0,11.4375 L0,12 L0.5625,12 L9.9375,12 L10.5,12 L10.5,11.4375 L10.5,7.3125 L10.5,6.75 L9.375,6.75 L9.375,7.3125 L9.375,10.875 L1.125,10.875 L1.125,2.625 L4.6875,2.625 L5.25,2.625 L5.25,1.5 L4.6875,1.5 L0.5625,1.5 Z"
            />
        </svg>
    );
};

export default React.memo(IconViewEdit);
